import {TranslateService} from '@ngx-translate/core';

export class Locale {
  static readonly LANGS = {
    EN_GB: {
      id: 'en-GB',
      flag: 'assets/icons/country-library/united-kingdom.svg',
      name: 'ENGLISH'
    },
    EN_US: {
      id: 'en-US',
      flag: 'assets/icons/country-library/united-states-of-america.svg',
      name: 'AMERICAN'
    },
    FR_FR: {
      id: 'fr-FR',
      flag: 'assets/icons/country-library/france.svg',
      name: 'FRANCAIS'
    }
  };

  public static getLocale(translateService: TranslateService, localeId: string) {
    return translateService.currentLang ?
      translateService.currentLang :
      (
        translateService.defaultLang ?
          translateService.defaultLang :
          localeId
      );
  }
}
